



























































import Vue from 'vue';
import scheduleRuleVuex from '../../../vuex/common';
import {
  PeriodicFreq,
  PeriodicDaily,
  PeriodicWeekly,
  PeriodicMonthly } from '../../../models/ScheduleRuleContext';

enum FreqType {
  Daily = 0,
  Weekly = 1,
  Monthly = 2,
}

enum WeekDays {
  Mon = 1,
  Tue = 2,
  Wed = 3,
  Thu = 4,
  Fri = 5,
  Sat = 6,
  Sun = 7,
}

const time: string | undefined = undefined;
const weekDays: number[] = [];
const days: number[] = [];
const freqType: FreqType = FreqType.Weekly as FreqType;
const monthlyDays = Array(28).fill(0).map((_, i) => i + 1);

export default Vue.extend({
  mixins: [scheduleRuleVuex],
  props: {
    freq: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      freqType,
      FreqType,
      weekDays,
      WeekDays,
      days,
      time,
      monthlyDays,
    };
  },
  methods: {
    validate() {
      if (this.freqType === FreqType.Weekly) {
        if (this.weekDays.length < 1) {
          this.$Message.warning('请选择需要推送的天数');
          return false;
        }
      }
      if (this.freqType === FreqType.Monthly) {
        if (this.days.length < 1) {
          this.$Message.warning('请选择需要推送的天数');
          return false;
        }
      }
      if (!this.time || this.time.trim() === '') {
        this.$Message.warning('请填写推送时间');
        return false;
      }
      return true;
    },
    confirmPeriodicFreq() {
      if (this.validate()) {
        const freq: PeriodicFreq = {} as PeriodicFreq;
        if (this.freqType === FreqType.Daily) {
          freq['Daily'] = {
            time: this.time!,
          } as PeriodicDaily;
        } else if (this.freqType === FreqType.Weekly) {
          freq['Weekly'] = {
            days: this.weekDays,
            time: this.time!,
          } as PeriodicWeekly;
        } else if (this.freqType === FreqType.Monthly) {
          freq['Monthly'] = {
            days: this.days,
            time: this.time!,
          } as PeriodicMonthly;
        }
        this.$store.commit('UPDATE_PERIODIC_FREQ', freq);
        this.$emit('close');
      }
    },
    initPeriodic() {
      if (this.freq) {
        if (this.freq.Daily) {
          this.freqType = FreqType.Daily;
          this.time = this.freq.Daily.time;
        } else if (this.freq.Weekly) {
          this.freqType = FreqType.Weekly;
          this.weekDays = this.freq.Weekly.days;
          this.time = this.freq.Weekly.time;
        } else if (this.freq.Monthly) {
          this.freqType = FreqType.Monthly;
          this.days = this.freq.Monthly.days;
          this.time = this.freq.Monthly.time;
        }
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initPeriodic();
    });
  },
});
